// src/features/canvas/utils/currency.ts
export const CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: '£',
  USD: '$',
  EUR: '€',
  AUD: 'A$',
  CAD: 'C$',
  AED: 'د.إ',
  JPY: '¥',
  CNY: '¥',
  DKK: 'kr',
  HKD: 'HK$',
  INR: '₹',
  NOK: 'kr',
  QAR: 'ر.ق',
  SAR: 'ر.س',
  SGD: 'S$',
  SEK: 'kr',
  ZAR: 'R',
  PKR: '₨',
  NZD: 'NZ$',
};

export const formatCurrencyParts = (
  amount: number,
  currency = 'GBP'
): { amount: string; symbol: string } => {
  const symbol = CURRENCY_SYMBOLS[currency] || currency;

  const formattedAmount = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.abs(amount));

  return { symbol, amount: formattedAmount };
};

export const formatCurrency = (amount: number, currency = 'GBP'): string => {
  const { symbol, amount: formattedAmount } = formatCurrencyParts(amount, currency);
  const sign = amount < 0 ? '-' : '';
  return `${sign}${symbol}${formattedAmount}`;
};
